const confirmBaseUrls = {
    dev: "https://dev.api.scisapp.com.dev.fortalsistemas.com.br/v2/coachees/confirm",
    alpha: "https://alpha.api.scisapp.com.staging.fortalsistemas.com.br/v2/coachees/confirm",
    prod: "https://prod.api.scisapp.com/v2/coachees/confirm",
};

export const confirmBaseUrl = confirmBaseUrls[process.env.REACT_APP_STAGE || 'dev'];
